<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="subcontractor.subcontractor_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <template v-if="is_subcontractor">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link to="/">
                                <i class="fa fa-id-badge"></i> Dashboard
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors`">
                                <i class="fa fa-id-badge"></i> Subcontractors
                            </router-link>
                        </li>
                    </template>
                    <li class="breadcrumb-item active">
                        {{ subcontractor.subcontractor_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            Subcontractor: <strong>{{ subcontractor.subcontractor_name }}</strong>

                            <div class="float-sm-right mt-sm-0 mt-3">
                                <router-link v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')" :to="`/subcontractors/delete/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>

                                <router-link v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage', 'subcontractors.edit'])" :to="`/subcontractors/edit/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Name:</div>
                                        <div class="col-md-8">{{ subcontractor.subcontractor_name }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Created:</div>
                                        <div class="col-md-8">{{ subcontractor.created_at | moment('timezone', this.$store.state.user.timezone, "MM/DD/YYYY") }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Last Updated:</div>
                                        <div class="col-md-8">{{ subcontractor.updated_at | moment("MM/DD/YYYY") }}</div>
                                    </div>

                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">OSHA Exempt: <i class="fa fa-question-circle" title="This subcontractor is exempt from being required to provide OSHA data"></i></div>
                                        <div class="col-md-8">
                                            <label v-if="subcontractor.is_osha_exempt === 1" class="badge badge-sm badge-warning">Yes</label>
                                            <label v-else class="badge badge-sm badge-default">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            Pre-Qualification

                            <div class="float-sm-right mt-sm-0 mt-3">
                                <router-link v-if="!is_subcontractor" :to="`/subcontractors/qualification/view/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-light" title="View Pre-Qualification">
                                    <i class="fa fa-check"></i> View
                                </router-link>

                                <router-link
                                    v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage', 'subcontractors.edit'])"
                                    :to="`/subcontractors/qualification/edit/${subcontractor.subcontractor_id}`"
                                    class="btn btn-sm btn-light"
                                    title="Edit Pre-Qualification">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>

                                <router-link v-if="is_subcontractor" to="/subcontractors/qualification/view" class="btn btn-sm btn-light">
                                    <i class="fa fa-check"></i> View Pre-Qualification
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Approved Until:</div>
                                        <div class="col-md-8">
                                            <template v-if="subcontractor.valid_until">{{ subcontractor.valid_until | moment("MM/DD/YYYY") }}</template>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">
                                            Status:
                                        </div>
                                        <div class="col-md-8">
                                            <label :title="subcontractor.status_desc" :class="`badge badge-${subcontractor.status_color}`">{{ subcontractor.status_name }}</label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="!is_subcontractor && mostRecentStatusComment">
                                        <div class="col text-muted text-md-right">
                                            Last Status Comment:
                                        </div>
                                        <div class="col-md-8">
                                            {{ mostRecentStatusComment.comment_details }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong><i class="fa fa-group"></i> Users</strong>
                            <div class="pull-right">
                                <router-link v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage'])" :to="`/users/create?subcontractor_id=${subcontractor.subcontractor_id}`" class="btn btn-sm btn-primary">
                                    <i class="fa fa-plus-circle"></i> Add
                                </router-link>
                            </div>
                        </div>
                        <div class="list-group list-group-flush">
                            <template v-if="users.length > 0">
                                <li class="list-group-item" v-for="user in users">
                                    <div class="media align-items-center">
                                        <div class="media-body">
                                            <router-link :to="`/users/view/${user.UserId}`" class="text-dark">
                                                {{ user.FirstName }} {{ user.LastName }}
                                            </router-link>
                                            <a :href="`mailto:${user.email}`" title="Email User">{{ user.email }}</a><br>
                                            <div class="text-muted">Last Login: <template v-if="user.LastLoginDate">{{ user.LastLoginDate | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</template></div>
                                            <span v-if="user.sub_permissions" class="badge badge-warning">{{ user.sub_permissions }}</span>
                                        </div>
                                    </div>
                                </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">-- No users --</li>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mt-4 mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'info'" @click="curTab = 'info'">
                    General Info
                </b-nav-item>

                <template v-if="!is_subcontractor">
                    <b-nav-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                        <i class="fa fa-comments"></i> Comments <span v-if="commentListCount">({{ commentListCount }})</span><span v-else>(0)</span>
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'files'" @click="curTab = 'files'">
                        <i class="fa fa-files-o"></i> Files ({{ files.length }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'actions'" @click="curTab = 'actions'" v-if="$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                        <i class="fa fa-wrench"></i> Corrective Actions ({{ actionListCount }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'ratings'" @click="curTab = 'ratings'">
                        <i class="fa fa-bar-chart"></i> Ratings <span v-if="averageRating">({{ averageRating }})</span>
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <i class="fa fa-life-ring"></i> Safety Meetings <span v-if="meetingListCount != null">({{ meetingListCount }})</span>
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <i class="fa fa-stethoscope"></i> Incidents <span v-if="incidentListCount != null">({{ incidentListCount }})</span>
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'osha'" @click="curTab = 'osha'">
                        OSHA Data
                    </b-nav-item>
                </template>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
              <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'info'" @click="curTab = 'info'">
                        General Info
                    </b-dropdown-item>

                    <template v-if="!is_subcontractor">
                        <b-dropdown-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                            <i class="fa fa-comments"></i> Comments <span v-if="commentListCount">({{ commentListCount }})</span><span v-else>(0)</span>
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'files'" @click="curTab = 'files'">
                            <i class="fa fa-files-o"></i> Files ({{ files.length }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'actions'" @click="curTab = 'actions'" v-if="$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                            <i class="fa fa-wrench"></i> Corrective Actions ({{ actionListCount }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'ratings'" @click="curTab = 'ratings'">
                            <i class="fa fa-bar-chart"></i> Ratings <span v-if="averageRating">({{ averageRating }})</span>
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                            <i class="fa fa-life-ring"></i> Safety Meetings <span v-if="meetingListCount != null">({{ meetingListCount }})</span>
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                            <i class="fa fa-stethoscope"></i> Incidents <span v-if="incidentListCount != null">({{ incidentListCount }})</span>
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'osha'" @click="curTab = 'osha'">
                            OSHA Data
                        </b-dropdown-item>
                    </template>
              </b-dropdown>
            </div>

            <div class="mt-2">
                <div class="card" v-show="curTab === 'info'">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Company Name:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.subcontractor_name }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Company Structure:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.comp_structure_name }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Address:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.address }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">City:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.city }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">State:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.state }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Zip:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.zip }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Phone:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.phone }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Fax:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.fax }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Website:</label>
                                    <div class="col-md-8">
                                        <a :href="(subcontractor.website.indexOf('http://') === -1 && subcontractor.website.indexOf('https://') === -1) ? `http://${subcontractor.website}` : subcontractor.website" v-if="subcontractor.website" target="_blank">{{ subcontractor.website }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Company Contact Name:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_name }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Company Contact Phone:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_phone }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Company Contact Email:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_email }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Office Type:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.office_name }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Other Names:</label>
                                    <div class="col-md-8">
                                        <span v-if="subcontractor.has_other_names == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_other_names == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Other Operating Names:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.other_names }}
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Business Start Date:</label>
                                    <div class="col-md-8">
                                        <template v-if="subcontractor.business_start_date">{{ subcontractor.business_start_date | moment("MM/DD/YYYY") }}</template>
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Business Age:</label>
                                    <div class="col-md-8">
                                        {{ subcontractorAge }} years
                                    </div>
                                </div>
                                <div class="row mb-sm-2 mb-3">
                                    <label class="col-md-3 text-muted text-md-right">Parent Company:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.parent_company }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="!is_subcontractor">
                    <div class="card" v-show="curTab === 'comments'">
                        <div class="card-body">
                            <comment-list :allowNewComments="!is_subcontractor" ref="commentList" :assetId="subcontractor.subcontractor_id" assetType="Subcontractor" @commentListCount="commentListCount = $event"></comment-list>
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'files'">
                        <div class="card-body">
                            <template v-if="!showFileUpload">
                                <button type="button" class="btn btn-sm btn-secondary" @click="showFileUpload = true">Add File</button>
                            </template>
                            <template v-else>
                                <button type="button" :disabled="saving" class="btn btn-sm btn-success" @click="addFile">Save</button>
                                <button type="button" :disabled="saving" class="btn btn-sm btn-secondary" @click="showFileUpload = false">Cancel</button>
                            </template>
                            <template v-if="showFileUpload">
                                <br>
                                <br>
                                <b-form-group :label-class="this.errors.file ? 'text-danger' : ''" :invalid-feedback="this.errors.file ? this.errors.file.join('<br>') : ''" label="File">
                                    <b-form-file v-model="new_file" :state="this.errors.file ? false : null" plain />
                                </b-form-group>
                                <b-form-group :label-class="this.errors.description ? 'text-danger' : ''" :invalid-feedback="this.errors.description ? this.errors.description.join('<br>') : ''" label="Description">
                                    <b-form-textarea v-model="new_file_comments" :state="this.errors.description ? false : null" rows="3"/>
                                </b-form-group>
                            </template>
                            <hr />
                            <file-table :files="files" :columns="file_columns" :allowDelete="true"/>
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'actions'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                        <div class="card-body">
                            <corrective-action-list assetType="Subcontractor" :assetId="this.subcontractor_id" @correctiveActionCount="actionListCount = $event" />
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'ratings'">
                        <div class="card-body">
                            <template v-if="rating_questions && rating_questions.length > 0">
                                <div v-if="showNewRating">
                                    <sub-rating-form :initialRating="new_rating" :ratingQuestions="rating_questions" :ratingLegend="(rating_legend ? rating_legend : '')" @cancelNewRating="showNewRating = false" @saveNewRating="previous_ratings.splice(0,0,$event); showNewRating = false"/>
                                </div>
                                <div v-else>
                                    <sub-rating-list :ratingLegend="(rating_legend ? rating_legend : '')" :ratings="previous_ratings" @averageRating="averageRating = $event" @editedRating="editedRating" @ratingDeleted="ratingDeleted" @showNewRating="showNewRating = true" />
                                </div>
                            </template>
                            <div class="alert alert-warning" v-else>
                                <p>You do not have the subcontractor evaluation questions setup. An admin can setup questions using the link below:</p>
                                <router-link to="/admin/subcontractor-settings" class="btn btn-sm btn-warning">Subcontractor Settings</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <div class="card-body">
                            <safety-meeting-list assetType="Subcontractor" :assetId="subcontractor.subcontractor_id" @safetyMeetingListCount="meetingListCount = $event" />
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <div class="card-body">
                            <incident-list assetType="Subcontractor" :assetId="parseInt(subcontractor_id)" @incidentListCount="incidentListCount = $event" />
                        </div>
                    </div>

                    <div class="card" v-show="curTab === 'osha'">
                        <div class="card-body">
                            <osha-sub-list :subcontractor_id="subcontractor.subcontractor_id" :allow_pinning="true" />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                curTab: 'info',
                loading: true,
                saving: false,
                subcontractor_id: this.$route.params.id,
                subcontractor: {},
                columns: ['sub_approval_id', 'client_name', 'approval_status_name', 'approval_created_at'],
                file_columns: ['file_id', 'file_name', 'user_id', 'created_at', 'description'],
                files: [],
                users: [],
                errors: {},
                showFileUpload: false,
                showNewRating: false,
                new_file: null,
                new_file_comments: null,
                is_subcontractor: this.$store.state.user.subcontractor_id,
                previous_ratings: [],
                rating_questions: [],
                rating_legend: null,
                new_rating: {ratings: []},
                commentListCount: null,
                actionListCount: null,
                averageRating: null,
                meetingListCount: null,
                incidentListCount: null,
                mostRecentStatusComment: null,

                settingsTabs: {
                    info: 'General Info',
                    comments: 'Comments',
                    files: 'Files',
                    actions: 'Corrective Actions',
                    meetings: 'Safety Meetings',
                    ratings: 'Ratings',
                    osha: 'OSHA Data',
                    incidents: 'Incidents',
                },
            }
        },

        computed: {

            subcontractorAge(){
                //Make sure we have a valid date
                if(!this.subcontractor.business_start_date)
                {
                    return '';
                }

                //Now
                var now = moment();
                var start = moment(this.subcontractor.business_start_date);

                //Send it
                return parseFloat(now.diff(start, 'days') / 365).toFixed(2);
            },

            tabButtonTitle(){
                //Send it
                var html = '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];

                //Switch
                switch(this.curTab)
                {
                    case 'comments':
                        //Append Count
                        html = '<i class="fa fa-comments"></i> ' + this.settingsTabs[this.curTab] + ' ('+this.commentListCount+')';
                        break;

                    case 'files':
                        //Append Count
                        html = '<i class="fa fa-files-o"></i> ' + this.settingsTabs[this.curTab] + ' ('+this.files.length+')';
                        break;

                    case 'actions':
                        //Append Count
                        html = '<i class="fa fa-wrench"></i> ' + this.settingsTabs[this.curTab] + ' ('+this.actionListCount+')';
                        break;

                    case 'meetings':
                        //Append Count
                        html = '<i class="fa fa-life-ring"></i> ' + this.settingsTabs[this.curTab] + ' ('+this.meetingListCount+')';
                        break;

                    case 'incidents':
                        //Append Count
                        html = '<i class="fa fa-stethoscope"></i> ' + this.settingsTabs[this.curTab] + ' ('+this.incidentListCount+')';
                        break;
                }

                //Send it
                return html;
            },
        },

        watch: {
            // It seems like comment list is pushing out the update before we have a chance to register the handler
            // nextTick waits until everything is loaded or something, and it does appear to be necessary
            // This is also hideous and some day we should figure out how to not need this whole function
            commentListCount(newValue) {
                this.$nextTick(function () {
                    this.$forceUpdate();
                });
            },

            actionListCount(newValue) {
                this.$nextTick(function () {
                    this.$forceUpdate();
                });
            },

            averageRating(newValue) {
                this.$nextTick(function () {
                    this.$forceUpdate();
                });
            },

            // Similar issue, when you add a file it doesn't redraw the files.length
            // This works, but like all good programmers, I have no idea why, or why it wasn't working in the first place
            // ¯\_(ツ)_/¯
            files(newValue) {
                this.$nextTick(function () {
                    this.$forceUpdate();
                });
            },

            JobsiteValues(){
                //check for null
                if(!this.new_rating.JobsiteId)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.new_rating.JobsiteId = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    return null;
                }

                return {JobsiteId: this.new_rating.JobsiteId, JobsiteNumber: this.new_rating.JobsiteNumber, JobsiteName: this.new_rating.JobsiteName};
            },
        },

        methods: {

            addFile: function() {
                this.saving = true;

                let data = {
                    description: this.new_file_comments,
                    asset_id: this.subcontractor_id,
                    asset_type: 'Subcontractor',
                    mime_types: 'jpeg,JPEG,jpg,JPG,png,PNG,pdf,PDF,docx,DOCX,xls,XLS,xlsx,XLSX',
                };

                this.$http
                    .postWithSingleFile('files/upload', data, this.new_file)
                    .then(response => {
                        this.updateFiles(response.data);

                        this.new_file = null;
                        this.new_file_comments = null;
                        this.errors = {};

                        // //Set loading
                        // this.loading = false;
                    })
                    .catch(error => {
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                    })
                    .then(response => {
                        this.saving = false;
                    });
            },

            getSubcontractor: function() {
                //Get the data
                this.$http
                    .get(`subcontractors/view${this.subcontractor_id ? '/'+this.subcontractor_id : ''}`)
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data.subcontractor;
                        this.files = response.data.files;
                        this.users = response.data.users;
                        this.previous_ratings = response.data.previous_ratings;
                        this.rating_questions = response.data.questions;
                        this.rating_legend = response.data.legend;
                        this.new_rating.ratings = JSON.parse(JSON.stringify(this.rating_questions));
                        this.mostRecentStatusComment = response.data.mostRecentStatusComment;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            updateFiles(data){
                //Alert the user
                this.$toastr.success('File Uploaded');

                //Set the value
                this.files.splice(0,0,data);

                //Hide the uploader
                this.uploadPrequalifiedFile = false;

                this.showFileUpload = false;
            },

            editedRating(data) {
                this.previous_ratings.splice(data.index,1,data.rating);
            },

            ratingDeleted(data) {
                //Send it
                this.previous_ratings.splice(data.index,1);

                //Refresh Other Suff?
            },
        },
        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>

<style>
    .no-form-group-margin .form-group {
        margin-bottom: 0;
    }
</style>
